import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { MatchingScore } from './MatchingScore.js';

@Entity()
export class MatchingScoreCache extends MongoEntity {
  static override _class = 'MatchingScoreCache';
  static override _collectionName = 'matchingScoreCache';

  @Field(() => ID)
  userID: Maybe<string>;

  @Field(() => ID)
  jobPositionID: Maybe<string>;

  @Field(() => MatchingScore)
  matchingScore: Maybe<MatchingScore>;

  @Field(() => Date)
  createdAt: Maybe<Date>;

  @Field(() => Date)
  updatedAt: Maybe<Date>;

  static override beforeCreate(entity: MatchingScoreCache): Promise<void> {
    entity.createdAt = new Date();
    entity.updatedAt = new Date();
    return super.beforeCreate(entity);
  }

  static override transformBeforeUpdate(
    oldEntity: PartialEntityData<MatchingScoreCache>,
    update: MatchingScoreCache,
  ): Promise<void> {
    update.updatedAt = new Date();
    return super.transformBeforeUpdate(oldEntity, update);
  }
}
